import React from 'react';
import PropTypes from 'prop-types';
import { generateBemCss } from 'general/js/helpers';

const MediaImagePost = ({ model }) => {
    const bemCss = generateBemCss('media-post', [model.type]);

    return (
        <div className={bemCss}>
            <div className="media-post__bg">
                {
                    model.imageSrc &&
                    <img
                        key={model.imageSrc}
                        className="lazyload"
                        data-srcset={model.imageSrc}
                        data-sizes="auto"
                        alt=""
                    />
                }
            </div>
            <div className="media-post__content">
                <h3 className="media-post__title">{model.title}</h3>
                <div className="media-post__body" dangerouslySetInnerHTML={{ __html: model.body }} />
            </div>
        </div>
    );
};

MediaImagePost.propTypes = {
    model: PropTypes.object.isRequired,
};

export default MediaImagePost;
